import { useState } from 'react'
import { useScrollEffect } from 'react-viewport-utils'

export const useIsScrollingDown = () => {
  const [isScrollingDown, setIsScrollingDown] = useState(false)
  useScrollEffect(({ isScrollingDown }) => setIsScrollingDown(isScrollingDown))
  return isScrollingDown
}

export const useIsScrollingUp = () => {
  const [isScrollingUp, setIsScrollingUp] = useState(false)
  useScrollEffect(({ isScrollingUp }) => setIsScrollingUp(isScrollingUp))
  return isScrollingUp
}
